import { Card, CardContent } from "../ui/card";

export function StatsGrid({ statCards }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {statCards.map((s, i) => (
                <Card key={s.label} className="border-border bg-card animate-fade-in" style={{ animationDelay: `${i * 0.05}s` }}>
                    <CardContent className="p-4">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-lg" style={{ backgroundColor: s.color + "15" }}>
                                <s.icon className="h-5 w-5" style={{ color: s.color }} />
                            </div>
                            <div>
                                <p className="text-xs text-muted-foreground">{s.label}</p>
                                <p className="text-xl font-bold text-foreground" data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
                                    {s.value}
                                </p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
